/**
 * Create a cargo with worker and payload.
 * You can put objects in payload any time before or after init cargo
 * You can stop cargo anytime without purging payload
 *
 *
 * const _cargo = new Cargo({ intervalDuration: 1 });
 * _cargo.push("gameId:1234", () => {
 *    setState(new Date().getTime() - props.time)
 * })
 */
import _forEach from "lodash/forEach";
// import { InteractionManager } from 'react-native'
interface CargoConfig {
  intervalDuration: number; // In seconds
}
class Cargo {
  payload: { [key: string]: any } | null = null;
  _interval: ReturnType<typeof setInterval> | null = null;
  _running = false;
  _count = 0;
  constructor(config: CargoConfig) {
    this._interval = setInterval(
      this.tick.bind(this),
      config.intervalDuration * 1000
    );
    /** Below code is failproof to avoid hat function issues */
    this.set = this.set.bind(this);
    this.purge = this.purge.bind(this);
    this.clean = this.clean.bind(this);
  }
  tick() {
    if (this._running) {
      return;
    }
    this._running = true;
    // InteractionManager.runAfterInteractions(() => {})
    _forEach(this.payload, (cb?: Function) => {
      if (typeof cb === "function") {
        cb();
      }
    });
    this._running = false;
  }
  set(id: string, cb: Function) {
    if (typeof this.payload !== "object") {
      this.payload = {};
    }
    if (this.payload === null) {
      this.payload = {};
    }
    this.payload[id] = cb;
    this._count += 1;
  }
  purge(id: string) {
    if (typeof this.payload !== "object" || this.payload === null) {
      return;
    }
    delete this.payload[id]; // Safe to access payload now
    this._count -= 1;
  }
  clean() {
    if (this._interval !== null) {
      clearInterval(this._interval);
    }
    this.payload = null;
    this._interval = null;
  }
}

export default new Cargo({ intervalDuration: 1 });
